const attendance = {
  studentAttendance: 'छात्र दैनिक उपस्थिति',
  studentAttendanceSubtitle: 'सभी कक्षाओं में दैनिक छात्र उपस्थिति का अवलोकन',
  teacherAttendanceTitle: 'कक्षा उपस्थिति',
  staffAttendance: 'स्टाफ़ उपस्थिति',
  staffAttendanceSubtitle: 'सभी शिक्षण और थेरेपी स्टाफ़ की दैनिक उपस्थिति ट्रैक करें',
  todayAttendance: 'आज की उपस्थिति',
  attendanceRecord: 'उपस्थिति रिकॉर्ड',
  previousDay: 'पिछला दिन',
  nextDay: 'अगला दिन',
  attendanceRate: 'उपस्थिति दर',
  bestAttendance: 'सर्वश्रेष्ठ उपस्थिति',
  needsAttention: 'ध्यान चाहिए',
  totalStaff: 'कुल स्टाफ़',
  present: 'उपस्थित',
  absent: 'अनुपस्थित',
  halfDay: 'आधा दिन',
  onLeave: 'छुट्टी पर',
  student: 'छात्र',
  class: 'कक्षा',
  attendance: 'उपस्थिति',
  remark: 'टिप्पणी',
  call: 'कॉल',
  staff: 'स्टाफ़',
  checkIn: 'चेक-इन',
  checkOut: 'चेक-आउट',
  status: 'स्थिति',
  presentLabel: 'उपस्थित',
  absentLabel: 'अनुपस्थित',
  presentClickToAbsent: 'उपस्थित — अनुपस्थित चिह्नित करने के लिए क्लिक करें',
  absentClickToPresent: 'अनुपस्थित — उपस्थित चिह्नित करने के लिए क्लिक करें',
  tapToToggle: '— टॉगल करने के लिए टैप करें',
  noRemark: 'कोई टिप्पणी नहीं',
  addRemark: 'टिप्पणी जोड़ें...',
  editRemark: 'टिप्पणी संपादित करें',
  markAllPresent: 'सभी को उपस्थित चिह्नित करें',
  markAllAbsent: 'सभी को अनुपस्थित चिह्नित करें',
  markAllPresentTitle: 'सभी को उपस्थित चिह्नित करें?',
  markAllAbsentTitle: 'सभी को अनुपस्थित चिह्नित करें?',
  markAllPresentMessage: 'यह आज के लिए सभी {{count}} छात्रों को उपस्थित चिह्नित करेगा। क्या आप सुनिश्चित हैं?',
  markAllAbsentMessage: 'यह आज के लिए सभी {{count}} छात्रों को अनुपस्थित चिह्नित करेगा। क्या आप सुनिश्चित हैं?',
  markAllStaffPresentMessage: 'यह आज के लिए सभी {{count}} स्टाफ़ सदस्यों को उपस्थित चिह्नित करेगा। क्या आप सुनिश्चित हैं?',
  markAllStaffAbsentMessage: 'यह आज के लिए सभी {{count}} स्टाफ़ सदस्यों को अनुपस्थित चिह्नित करेगा। क्या आप सुनिश्चित हैं?',
  notifyParents: '{{count}} अभिभावक को सूचित करें',
  notifyParentsPlural: '{{count}} अभिभावकों को सूचित करें',
  absentStudentsToday: '{{count}} छात्र आज अनुपस्थित चिह्नित',
  absentStudentsTodayPlural: '{{count}} छात्र आज अनुपस्थित चिह्नित',
  sendAbsenceAlerts: 'अनुपस्थिति अलर्ट भेजें?',
  notifyAbsenceMessage: "यह {{count}} अनुपस्थित छात्र ({{names}}) के अभिभावकों को सूचित करेगा। अभिभावकों को आज के अनुपस्थिति विवरण के साथ एक ईमेल प्राप्त होगा।",
  notifyAbsenceMessagePlural: "यह {{count}} अनुपस्थित छात्रों ({{names}}) के अभिभावकों को सूचित करेगा। अभिभावकों को आज के अनुपस्थिति विवरण के साथ एक ईमेल प्राप्त होगा।",
  parentsNotified: 'अभिभावकों को सूचित किया गया',
  absenceAlertsSent: '<strong>{{count}} छात्र</strong> के लिए अनुपस्थिति अलर्ट भेजे गए — {{names}}{{suffix}}।',
  absenceAlertsSentPlural: '<strong>{{count}} छात्रों</strong> के लिए अनुपस्थिति अलर्ट भेजे गए — {{names}}{{suffix}}।',
  andMore: ' और {{count}} और',
  studentsShown: '{{count}} छात्र दिखाए गए',
  staffShown: '{{count}} स्टाफ़ दिखाए गए',
  readOnlyHistorical: 'केवल पढ़ने के लिए — ऐतिहासिक रिकॉर्ड',
  toggleToMark: 'उपस्थिति चिह्नित करने के लिए टॉगल करें',
  noAttendanceRecords: 'कोई उपस्थिति रिकॉर्ड नहीं मिला',
  noStaffAttendanceRecords: 'कोई स्टाफ़ उपस्थिति रिकॉर्ड नहीं मिला',
  liveCheckInIndicator: '<strong>{{count}}</strong> स्टाफ़ सदस्य ने आज डैशबोर्ड के माध्यम से चेक इन किया — चेक-इन समय अब नीचे तालिका में दिखाई दे रहा है।',
  liveCheckInIndicatorPlural: '<strong>{{count}}</strong> स्टाफ़ सदस्यों ने आज डैशबोर्ड के माध्यम से चेक इन किया — चेक-इन समय अब नीचे तालिका में दिखाई दे रहा है।',
  presentOf: 'उपस्थित',
  backToDashboard: 'डैशबोर्ड पर वापस जाएं',
  onLeaveLabel: 'छुट्टी पर',

  // Action dropdown
  actionsFor: '{{name}} के लिए कार्रवाइयाँ',
  actions: 'कार्रवाइयाँ',
  alert: 'अलर्ट',
  preInspectionTransitLogging: 'पूर्व-निरीक्षण और ट्रांज़िट लॉगिंग',
  preInspectionDescription: 'मूड, शारीरिक स्थिति, सामान की जाँच',
  classroomIncidentEmergency: 'कक्षा घटना और आपातकालीन रिकॉर्डिंग',
  incidentDescription: 'घटना का प्रकार, गंभीरता, की गई कार्रवाई',

  // Pre-Inspection form
  newLog: 'नया लॉग',
  logHistory: 'लॉग इतिहास',
  logAnother: 'और लॉग करें',
  studentMood: 'छात्र का मूड',
  physicalState: 'शारीरिक स्थिति',
  belongingsOnPickup: 'पिकअप पर सामान',
  additionalNotes: 'अतिरिक्त नोट्स',
  notesPlaceholder: 'जैसे, छात्र रोता हुआ आया, अभिभावक ने बताया कि रात को ठीक से नींद नहीं आई...',
  cannedMessages: 'पूर्व-निर्धारित संदेश',
  notifyParent: 'अभिभावक को सूचित करें',
  notifyParentHint: 'स्वचालित रूप से सारांश संदेश तैयार करें और भेजें',
  sendVia: 'के माध्यम से भेजें',
  messagePreview: 'संदेश पूर्वावलोकन',
  preInspectionUpdate: 'पूर्व-निरीक्षण अपडेट',
  dateLabel: 'तारीख',
  moodLabel: 'मूड',
  notesLabel: 'नोट्स',
  notRecorded: 'रिकॉर्ड नहीं किया गया',
  savePreInspection: 'पूर्व-निरीक्षण लॉग सहेजें',
  preInspectionSaved: 'पूर्व-निरीक्षण लॉग सहेजा गया!',
  preInspectionSavedHint: '{{name}} का पूर्व-निरीक्षण रिकॉर्ड सफलतापूर्वक सहेजा गया है।',
  todayLogExists: 'इस छात्र के लिए आज पहले से एक पूर्व-निरीक्षण लॉग मौजूद है। यदि आवश्यक हो तो आप फिर भी एक और बना सकते हैं।',
  recordedBy: 'द्वारा रिकॉर्ड किया गया',
  noPreInspectionLogs: 'अभी तक कोई पूर्व-निरीक्षण लॉग नहीं',
  noPreInspectionLogsHint: 'ऊपर दिए गए फॉर्म का उपयोग करके अपना पहला लॉग बनाएं',

  // Daywise Pre-Inspection Logs
  preInspectionLogs: 'पूर्व-निरीक्षण लॉग',
  preInspectionLogsForDate: '{{date}} के लिए पूर्व-निरीक्षण लॉग',
  viewAllPreInspectionLogs: 'सभी पूर्व-निरीक्षण लॉग देखें',
  noLogsForDate: 'इस तारीख के लिए कोई पूर्व-निरीक्षण लॉग नहीं',
  noLogsForDateHint: 'जब स्टाफ़ छात्रों के लिए पूर्व-निरीक्षण रिकॉर्ड करेगा तो लॉग यहाँ दिखाई देंगे',

  // Incident form
  newIncident: 'नई घटना',
  incidentHistory: 'घटना इतिहास',
  incidentType: 'घटना का प्रकार',
  severityLevel: 'गंभीरता स्तर',
  incidentLocation: 'स्थान',
  locationLabel: 'स्थान',
  incidentDescription: 'विवरण',
  incidentDescriptionPlaceholder: 'विस्तार से बताएं कि क्या हुआ...',
  actionsTaken: 'की गई कार्रवाइयाँ',
  actionsTakenPlaceholder: 'प्राथमिक चिकित्सा, डी-एस्केलेशन, अभिभावक संपर्क...',
  actionsTakenLabel: 'कार्रवाइयाँ',
  staffInvolved: 'शामिल स्टाफ़',
  staffInvolvedLabel: 'स्टाफ़',
  staffInvolvedPlaceholder: 'जैसे, Ms. Emily Watson, Dr. Sarah Mitchell',
  followUpRequiredQuestion: 'फॉलो-अप आवश्यक है?',
  followUpRequiredHint: 'फॉलो-अप समीक्षा के लिए इस घटना को चिह्नित करें',
  followUpRequired: 'फॉलो-अप आवश्यक',
  followUpNotes: 'फॉलो-अप नोट्स',
  followUpNotesPlaceholder: 'जैसे, अभिभावक बैठक शेड्यूल करें, 3 दिनों तक निगरानी करें...',
  incidentNotifyParentHint: 'अभिभावक को घटना का सारांश भेजें',
  saveIncident: 'घटना रिपोर्ट सहेजें',
  incidentSaved: 'घटना रिपोर्ट सहेजी गई!',
  incidentSavedHint: '{{name}} की घटना रिपोर्ट सफलतापूर्वक रिकॉर्ड की गई है।',
  noIncidentLogs: 'अभी तक कोई घटना रिपोर्ट नहीं',
  noIncidentLogsHint: 'ऊपर दिए गए फॉर्म का उपयोग करके अपनी पहली घटना रिपोर्ट बनाएं',

  // Daywise incident logs
  incidentLogs: 'घटना रिपोर्ट',
  incidentLogsForDate: '{{date}} के लिए घटना रिपोर्ट',
  viewAllIncidentLogs: 'सभी घटना रिपोर्ट देखें',
  noIncidentsForDate: 'इस तारीख के लिए कोई घटना रिपोर्ट नहीं',
  noIncidentsForDateHint: 'जब स्टाफ़ छात्रों के लिए घटनाएँ रिकॉर्ड करेगा तो रिपोर्ट यहाँ दिखाई देंगी',
};

export default attendance;